import { FC } from 'react';

import { useSidebar } from '../../hooks/sidebar';

import { Header, Sidebar, MenuBottom } from '..';

import { Container, Main, Content } from './styles';

interface LayoutProps {
  title: string;
}

const Layout: FC<LayoutProps> = ({ title, children }) => {
  const { toggleSidebar, sidebarIsVisible } = useSidebar();

  return (
    <Container>
      <Sidebar sidebarIsVisible={sidebarIsVisible} />

      <Main>
        <Header toggleSidebar={toggleSidebar} title={title} />
        <Content>{children}</Content>
      </Main>

      <MenuBottom />
    </Container>
  );
};

export default Layout;
